import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './TouchModal.module.scss';

const propTypes = {
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool,
};

class TouchModal extends Component {
  constructor(props) {
    super(props);
    this._element = document.createElement('div');
    this._portalRoot = null;
  }

  componentDidMount() {
    if (this.props.isOpen) {
      this.openPortal();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.isOpen && !prevProps.isOpen) {
      this.openPortal();
    } else if (!this.props.isOpen && prevProps.isOpen) {
      this.closePortal();
    }
  }

  componentWillUnmount() {
    this.closePortal();
  }

  openPortal() {
    if (!document.body.contains(this._element)) {
      document.body.appendChild(this._element);
    }
    document.body.classList.add(styles.isTouchModalOpen);
    this._portalRoot = true;
    this.forceUpdate(); // Trigger re-render to mount the portal
  }

  closePortal() {
    if (document.body.contains(this._element)) {
      document.body.removeChild(this._element);
    }
    document.body.classList.remove(styles.isTouchModalOpen);
    this._portalRoot = false;
    this.forceUpdate();
  }

  renderChildren() {
    const { children, isOpen } = this.props;
    return (
      <div className={cx(styles.TouchModal, { [styles.isOpen]: isOpen })}>
        <div className={styles.Wrapper}>
          {children}
        </div>
      </div>
    );
  }

  render() {
    if (!this._portalRoot || !this.props.isOpen) return null;

    return ReactDOM.createPortal(
      this.renderChildren(),
      this._element
    );
  }
}

TouchModal.propTypes = propTypes;

export default TouchModal;
